/**
 * What an applicant says they are when they sign up. One or more.
 *
 * Read this next to `RoleKey` in ./roles.ts, because the two look alike and
 * are opposites. A `RoleKey` is DERIVED from a grant and decides what you may
 * do. A `DeclaredMemberType` is TICKED IN A FORM by the applicant: it is
 * profile data, it is shown back to them, and it will inform the permissions
 * layer — but on its own it creates no organisation, no membership, and no
 * workspace. Nothing in `deriveWorkspaces()` reads it.
 *
 * That separation is the whole reason signup is safe to expose publicly. If
 * ticking "Gallery" minted a gallery grant, the form would be a
 * privilege-escalation surface.
 *
 * Several at once is the normal case, not an edge one: a gallery director also
 * collects, an estate also consigns to auction, an advisor also manages a
 * collection. These are descriptions of what someone does, and people do more
 * than one thing.
 *
 * These values must stay in step with the `ondo.declared_member_type` enum in
 * supabase/migrations.
 */
export const DECLARED_MEMBER_TYPES = [
    "artist",
    "artist_estate",
    "collector",
    "gallery",
    "auction_house",
    "art_advisor",
    "museum",
    "collection_manager",
];
export function isDeclaredMemberType(value) {
    return (typeof value === "string" &&
        DECLARED_MEMBER_TYPES.includes(value));
}
/**
 * Dedupes a selection and puts it in the canonical order above.
 *
 * Both halves matter. Order, because otherwise the summary line and the stored
 * array read back in whatever sequence the boxes happened to be ticked, and
 * two people who chose the same things would look different. Dedupe, because
 * the array reaches a Postgres column and the client is not trusted to send a
 * tidy one.
 */
export function normaliseDeclaredTypes(values) {
    return DECLARED_MEMBER_TYPES.filter((type) => values.includes(type));
}
/** Adds or removes one type, keeping the result canonical. */
export function toggleDeclaredType(values, type) {
    return normaliseDeclaredTypes(values.includes(type) ? values.filter((value) => value !== type) : [...values, type]);
}
//# sourceMappingURL=membership.js.map